import React                from 'react'
import { 
    Container, 
    Content,
    Section
}                           from './component'

const About = () => {
    return (
        <Container>
            <Content>
                <Section />
            </Content>
        </Container>
    )
}

export default About; 
